// extracted by css-extract-rspack-plugin
export default {"container":"product-detail-fragment__RatingAndParticipantsContainer_container__AkYVN"};